import { LoggedUserType, SelectOptionType } from "../models/GlobalModels";
import { API_RESPONSE_CODE, ICV_STATUS, STORAGE_KEY } from "./Constant";
import { ROLE_IDS } from "./RBAC";

export const clearSession = () => {
  sessionStorage.clear(); //clear outlook detail
};

export const getFromLocalStorage = (key: string) => {
  const data = localStorage.getItem(key);
  return data ? data : "";
};

export const removeFromLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};

export const saveInLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

export const isAPIFailed = (fulfilled: any) => {
  if (
    fulfilled.responseInformation &&
    fulfilled.responseInformation &&
    fulfilled.responseInformation.responseCode === API_RESPONSE_CODE.FAIL
  ) {
    return true;
  } else {
    return false;
  }
};
export const isAPISuccess = (fulfilled: any) => {
  if (
    fulfilled.responseInformation &&
    fulfilled.responseInformation &&
    fulfilled.responseInformation.responseCode === API_RESPONSE_CODE.SUCCESS
  ) {
    return true;
  } else {
    return false;
  }
};

export const getUser = (): LoggedUserType => {
  let user: LoggedUserType = {
    accessToken: "",
    accessExpiryTime: "",
    candidateUniqueId: "",
    employeeName: "",
    emailId: "",
    permissions: [],
    resetToken: "",
    resetExpiryTime: "",
    roleId: -1,
    roleName: [],
    sessionId: "",
    userId: "",
    accessedStates: [],
    accessedDistricts: [],
  };
  const data = localStorage.getItem(STORAGE_KEY.AUTH_DATA);
  if (data) {
    user = JSON.parse(data);
  }
  return user;
};

export const regionContainingPoints = (points: any) => {
  let minLat: number, maxLat: number, minLng: number, maxLng: number;

  // Initialize first point
  ((point) => {
    minLat = point.centroid.lat;
    maxLat = point.centroid.lat;
    minLng = point.centroid.lng;
    maxLng = point.centroid.lng;
  })(points[0]);

  // Calculate rect points
  points.forEach((point: any) => {
    minLat = Math.min(minLat, point.centroid.lat);
    maxLat = Math.max(maxLat, point.centroid.lat);
    minLng = Math.min(minLng, point.centroid.lng);
    maxLng = Math.max(maxLng, point.centroid.lng);
  });

  const midLat = (minLat + maxLat) / 2;
  const midLng = (minLng + maxLng) / 2;
  // const deltaLat = maxLat - minLat;
  // const deltaLng = maxLng - minLng;

  return {
    lat: midLat,
    lng: midLng,
  };
};

export const dateConverter = (sdate: string, datetype : string) => {
  let fromDate = new Date(sdate);
  let toDate = new Date(sdate);
  let convertedDate;
    if(datetype === "fromDate"){
      convertedDate = fromDate.setDate(fromDate.getDate() );
    }else {
      convertedDate = toDate.setDate(toDate.getDate() + 1);
    }

  var date = new Date(convertedDate);
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let day = ("0" + date.getDate()).slice(-2);
  return `${date.getFullYear()}-${month}-${day}`;
};

export const dateConverterWithoutAddingDays = (sdate: string, datetype : string) => {
  let fromDate = new Date(sdate);
  let toDate = new Date(sdate);
  let convertedDate;
    if(datetype === "fromDate"){
      convertedDate = fromDate.setDate(fromDate.getDate());
    }else {
      convertedDate = toDate.setDate(toDate.getDate());
    }

  var date = new Date(convertedDate);
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let day = ("0" + date.getDate()).slice(-2);
  return `${date.getFullYear()}-${month}-${day}`;
};

export const isWithin30Meters = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
) => {
  // Radius of earth in kilometers
  var R = 6371.0;

  // Convert degrees to radians
  var lat1Rad = toRadians(lat1);
  var lon1Rad = toRadians(lon1);
  var lat2Rad = toRadians(lat2);
  var lon2Rad = toRadians(lon2);

  // Differences
  var dlat = lat2Rad - lat1Rad;
  var dlon = lon2Rad - lon1Rad;

  // Haversine formula
  var a =
    Math.sin(dlat / 2) ** 2 +
    Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(dlon / 2) ** 2;
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  // Distance in kilometers
  var distance = R * c;

  // Convert distance to meters and check if it's less than or equal to 30
  return distance * 1000 <= 30;
};

export const toRadians = (degrees: number) => {
  return degrees * (Math.PI / 180);
};

export const filterICVStatus = (data: any[]) => {
  let filteredData =  data?.filter((status: any) => {
    return status?.value != ICV_STATUS.ASSIGNED && status?.value != ICV_STATUS.COMPLETED
  });  
  filteredData.push({label: 'Completed', value: ICV_STATUS.COMPLETED});
  return filteredData;
}

export const getStatusStyles = (status: string) => {
  if(status === 'Completed'){
    return 'status-completed';
  }
  else if(status === 'QC In Progress') {
    return 'status-qc-inprogress';
  }
  else if (status === 'Reassigned') {
    return 'status-reassigned';
  }
  else {
    return '';
  }
}

// Consolidated function to filter options based on user role and accessed data
export const filterOptionsByRole = (
  options: any[],
  userRoleId: number,
  accessedStates: string[] = [],
  accessedDistricts: string[] = [],
  filterType: 'states' | 'districts' = 'states'
): any[] => {
  // Admin and HO level coordinators see all options
  if (userRoleId === ROLE_IDS.ADMIN_USER || userRoleId === ROLE_IDS.HO_LEVEL_COORDINATORS) {
    return options;
  }

  // State coordinators
  if (userRoleId === ROLE_IDS.STATE_LEVEL_COORDINATORS) {
    if (filterType === 'states') {
      return options.filter(option => accessedStates.includes(option.value?.toString()));
    } else {
      // For districts, show all (no filtering needed as they're already filtered by state)
      return options;
    }
  }

  // Cluster coordinators
  if (userRoleId === ROLE_IDS.CLUSTER_LEVEL_COORDINATORS) {
    if (filterType === 'states') {
      return options.filter(option => accessedStates.includes(option.value?.toString()));
    } else {
      return options.filter(option => accessedDistricts.includes(option.value?.toString()));
    }
  }

  // Default: show all options
  return options;
};